import { render } from "./ModalImagem.vue?vue&type=template&id=74c73c21&scoped=true"
import script from "./ModalImagem.vue?vue&type=script&lang=js"
export * from "./ModalImagem.vue?vue&type=script&lang=js"

import "./ModalImagem.vue?vue&type=style&index=0&id=74c73c21&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c73c21"]])

export default __exports__